import { render, staticRenderFns } from "./upstreamCustomerAdd.vue?vue&type=template&id=94dfa0fa&scoped=true"
import script from "./upstreamCustomerAdd.vue?vue&type=script&lang=js"
export * from "./upstreamCustomerAdd.vue?vue&type=script&lang=js"
import style0 from "./upstreamCustomerAdd.vue?vue&type=style&index=0&id=94dfa0fa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "94dfa0fa",
  null
  
)

export default component.exports